
import { DOASSIGNDUPLICATES_TYPES } from '../actions/doAssignDuplicates'
import reducer, { defaultState } from './requests'
const Reducer = (state = defaultState, action) => {
    let requestReducer = reducer(DOASSIGNDUPLICATES_TYPES)(state, action)
    if (requestReducer !== null) return requestReducer
    switch (action.type) {
        default:
            return state
    }
}
export default Reducer